import {LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE} from '../actions/AccountActions'
import {LOGOUT_REQUEST, LOGOUT_SUCCESS, LOGOUT_FAILURE} from '../actions/AccountActions'
import {USER_SET_PREFERRED_SUCCESS} from '../actions/PresetActions';
import {Defaults} from '../Constants';
import omit from 'lodash/omit';

const AUTH_STORE_KEY = 'authStore';

const initialState = JSON.parse(localStorage.getItem(AUTH_STORE_KEY)) || {
    isAuthenticating: false,
    isAuthenticated: false,
    currentUser: {
        preferredAmplitude: Defaults.AMPLITUDE,
        preferredSpread: Defaults.SPATIAL_SCALE,
    },
    error: null
};

function authInternal(state, action) {
    switch (action.type) {
        case LOGIN_REQUEST:
            return {...state, isAuthenticating: true, error: null};
        case LOGIN_SUCCESS:
            return {isAuthenticating: false, isAuthenticated: true, error: null, currentUser: action.user};
        case LOGIN_FAILURE:
            return {...state, isAuthenticating: false, isAuthenticated: false, error: action.error, currentUser: {}};
        case LOGOUT_REQUEST:
            return {...state, error: null};
        case LOGOUT_SUCCESS:
            return {isAuthenticating: false, isAuthenticated: false, error: null, currentUser: {}};
        case LOGOUT_FAILURE:
            return {...state, error: action.error};
        case USER_SET_PREFERRED_SUCCESS:
            const {id, amplitude, spread} = action;
            if (id === state.currentUser.id) {
                return {...state, currentUser: {...state.currentUser, preferredAmplitude: amplitude, preferredSpread: spread}};
            }
            break;
        default:
            break;
    }
    return state;
}

export function auth(state, action) {
    const newState = authInternal(state || initialState, action);
    if (newState !== state) {
        localStorage.setItem(AUTH_STORE_KEY, JSON.stringify(omit(newState, 'error')));
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js